module.exports = __webpack_public_path__ + "static/img/grab_active.bbb3c4ee.png";